import api from "../lib/axios";

const BASE_URL = "/Auth";

export const authService = {
  loginAsync: async (params) => {
    // Fixed: Sending data body directly instead of nesting inside an object called params
    const response = await api.post(`${BASE_URL}/login`, params);
    return response.data;
  },
  checkAuthenticationAsync: async () => {
    const response = await api.get(`${BASE_URL}/check-authentication`);
    return response.data;
  },
  logoutAsync: async () => {
    const response = await api.get(`${BASE_URL}/logout`);
    return response.data;
  },
};